"use client";

import { Swiper } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";

export const STSwiper = ({
  children,
  prevClass,
  nextClass,
  slidesPerView = 1,
  spaceBetween = 24,
  breakpoints = {},
  className = "",
  loop = false,
  autoplay = false,
  autoplayDelay = 3000,
  speed = 1000,
  isMarquee = false,
  reverse = false,
}) => {
  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      breakpoints={breakpoints}
      loop={loop || isMarquee}
      speed={isMarquee ? 4000 : speed}
      autoplay={
        autoplay || isMarquee
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
              reverseDirection: isMarquee ? reverse : false,
            }
          : false
      }
      navigation={
        prevClass && nextClass
          ? {
              prevEl: prevClass,
              nextEl: nextClass,
            }
          : false
      }
      onBeforeInit={(swiper) => {
        if (prevClass && nextClass) {
          swiper.params.navigation.prevEl = prevClass;
          swiper.params.navigation.nextEl = nextClass;
        }
      }}
      className={className}
    >
      {children}
    </Swiper>
  );
};
